/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetUsersProfileQueryResponse, GetUsersProfile400 } from "../entities/GetUsersProfile";

function getGetUsersProfileUrl() {
  const res = { method: 'GET', url: `/users/profile` as const }  
  return res
}

/**
 * @description Получение профиля
 * @summary Получение профиля
 * {@link /users/profile}
 */
export async function getUsersProfile(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetUsersProfileQueryResponse, ResponseErrorConfig<GetUsersProfile400>, unknown>({ method : "GET", url : getGetUsersProfileUrl().url.toString(), ... requestConfig })  
  return res.data
}